import React, { useState } from 'react';
import { Button } from 'rsuite';

function Itinerary(props) {
  const [viewAllPorts, setViewAllPorts] = useState(false);

  function handleSeeMoreChange() {
    setViewAllPorts(!viewAllPorts);
  }
  function FormatTime(timeString) {
    if (!timeString) {
      return "";
    }

    let pieces = timeString.split(":");
    return pieces[0] + ":" + pieces[1];
  }

  function SequenceName(seq) {
    if (seq < 0) {
      return "Pre cruise"
    }
    else if (seq > 0) {
      return "Post cruise"
    }
    else {
      return "Main cruise"
    }
  }

  function port(sequence, sp) {
    return (
      <div key={sequence + '_' + sp.sequence} className="table-row">
        <div className="table-cell">
          {sp.stopPoint.image && <img alt="Stoppoint" src={props.pictureserver + sp.stopPoint.image} />}
        </div>
        <div className="table-cell h-0 px-4 align-top">
          <div className="flex flex-col h-full">
            <div className="bg-black text-white p-3">
              {sp.day}
            </div>
            <div className="w-1/2 h-full border-solid border-r-2 border-black" style={{ minHeight: 20 }} />
          </div>
        </div>
        <div className="table-cell align-top">
          <div className="text-lg font-semibold" >{sp.stopPoint.name}, {sp.stopPoint.country}</div>
          {sp.day == 1
            ?
            <div className="font-semibold">
              Departure: {props.cruisepackages.map((cp) =>
              new Intl.DateTimeFormat("en-GB", {
                day: "2-digit",
                month: "long"
              }).format(new Date(cp.departure)) + " | ")}
            </div>
            :
            <div></div>
          }
          <div dangerouslySetInnerHTML={{ __html: sp.stopPoint.shortDescription }}></div>
        </div>
      </div >
    );
  }

  function gallery(gallery) {

    if (gallery.length > 0) {
      let accordionId = 1;

      return (
        <div>
          <h3 className="mt-3">Gallery</h3>

          {gallery.map((type) =>
            <div id={"galleryAccordion" + accordionId}>
              <div key={type.imageSubType}>
                <div className="col-12">
                  <h4><a className="card-link" data-toggle="collapse" href={"#collapse" + type.imageSubType}>{type.imageSubType}</a></h4>
                </div>
                <div id={"collapse" + type.imageSubType} className="collapse" data-parent={"#galleryAccordion" + accordionId++}>
                  {type.images.map((pic) =>
                    <React.Fragment>
                      <div className="my-3 row border-bottom">
                        <div className="col-12 col-sm-4 col-md-3 mb-3">
                          <img alt="gallery" src={pic.filePath} style={{ maxHeight: '300px', maxWidth: '300px', width: '100%' }} />
                        </div>
                        <div className="col-12 col-sm-8 col-md-9 mb-3">{pic.description}</div>
                      </div>
                    </React.Fragment>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      );
    }
  }

  {/*if (props.itineraries.length === 1) {
    return (
      <React.Fragment>
        {props.itineraries.map((it) =>
          <React.Fragment key={it.sequence}>
            {it.stopPoints.map((sp) => port(it, sp))}
          </React.Fragment>
        )
        }
      </React.Fragment>
    )
  }
  else {
    return (
      <React.Fragment>
        {props.itineraries.map((it) =>
          <div key={it.sequence} className="card my-3">
            <div className="card-header">{SequenceName(it.sequence)}</div>
            <div className="card-body">
              {it.stopPoints.map((sp) => port(it, sp))}
            </div>
          </div>
        )
        }
      </React.Fragment>
    )
  }*/}

  let stoppointNameList = "";
  const numberOfStoppoints = props.itineraries[0].stopPoints.length;
  props.itineraries[0].stopPoints.map((sp, index) => {
    stoppointNameList += sp.stopPoint.name;
    if (index < numberOfStoppoints - 1) {
      stoppointNameList += " - ";
    }
  });

  return (
    <React.Fragment>
      <div className="text-center py-3">
        <span className="text-xl font-semibold">Daily plan</span>
        <p className="text-lg mx-auto w-8/12">{stoppointNameList}</p>
      </div>
      <div className="flex">
        <div className="p-3 w-1/3">
          <img src="/img/Barcelona_roundtrip.jpg" alt="Map" />
        </div>
        <div className="p-3 w-2/3">
          {props.itineraries.map((it) =>
            <div key={it.sequence} className="table">
              {viewAllPorts
                ?
                it.stopPoints.map((sp) =>
                  <React.Fragment key={it.sequence + "_" + sp.sequence + "_wrapper"}>
                    {port(it.sequence, sp)}
                    {
                      sp.sequence < numberOfStoppoints - 1
                        ? <React.Fragment>
                          <div className="table-row ">
                            <div className="table-cell"></div>
                            <div className="table-cell text-center"></div>
                            <div className="table-cell">
                              {sp.sequence == 0
                                ?
                                <span className="underline whitespace-no-wrap cursor-pointer px-1"
                                  onClick={handleSeeMoreChange}>
                                  See less
                                </span>
                                : null
                              }
                            </div>
                          </div>
                          <div className="table-row">
                            <div className="table-cell"></div>
                            <div className="table-cell">
                              <div className="w-1/2 h-8 border-solid border-r-2 border-black" />
                            </div>
                            <div className="table-cell "></div>
                          </div>
                        </React.Fragment>
                        : null
                    }
                  </React.Fragment>
                )
                :
                <React.Fragment>
                  {port(it.sequence, it.stopPoints[0])}
                  <div className="table-row">
                    <div className="table-cell"></div>
                    <div className="table-cell">
                      <div className="w-1/2 h-3 mt-6 border-solid border-r-2 border-black" />
                    </div>
                    <div className="table-cell "></div>
                  </div>
                  <div className="table-row">
                    <div className="table-cell"></div>
                    <div className="table-cell">
                      <div className="w-1/2 h-3 mt-4 border-solid border-r-2 border-black" />
                    </div>
                    <div className="table-cell "></div>
                  </div>
                  <div className="table-row">
                    <div className="table-cell"></div>
                    <div className="table-cell text-center"></div>
                    <div className="table-cell ">
                      <span className="underline whitespace-no-wrap cursor-pointer px-1"
                        onClick={handleSeeMoreChange}>
                        See more
                        </span>
                    </div>
                  </div>
                  <div className="table-row">
                    <div className="table-cell"></div>
                    <div className="table-cell">
                      <div className="w-1/2 h-8 border-solid border-r-2 border-black" />
                    </div>
                    <div className="table-cell "></div>
                  </div>
                  {port(it.sequence, it.stopPoints[it.stopPoints.length - 1])}
                </React.Fragment>
              }
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
}

export default Itinerary;